import { Box, Button, styled } from "@mui/material";
import { TEXT_STYLE } from "./Factory/GameTimelineFactory.styles";

export const HeaderContainer = styled(Box, {
    shouldForwardProp: (prop) => prop !== "isTimelinePage",
})<{ isTimelinePage?: boolean }>(({ isTimelinePage = false }) => ({
    display: "flex",
    justifyContent: "space-between",
    width: "100%",
    ...(isTimelinePage && {
        padding: "12px",
        marginBottom: "12px",
    }),
}));

export const ContentContainer = styled(Box, {
    shouldForwardProp: (prop) => prop !== "isInPostDetails",
})<{ isInPostDetails?: boolean }>(({ isInPostDetails = false }) => ({
    marginTop: isInPostDetails ? "16px" : "12px",
    marginBottom: isInPostDetails ? "16px" : "12px",
}));

export const OpenGameTimelineButton = styled(Button)({
    ...TEXT_STYLE,
    color: "var(--community-color-snow-white)",
    borderRadius: "90px",
    background: "var(--community-color-light-steal-blue)",
    padding: "4px 16px",
    display: "flex",
    margin: "12px auto 0",
    textTransform: "none",
});
